import { gql } from '@apollo/client';

export const previewSubscriptionQuery = gql`
  query ECOMMERCE_previewSubscription($input: PurchaseSubscriptionInput!) {
    previewSubscription(input: $input) {
      activationFeeInCents
      waivedActivationFeesInCents
      taxInCents
      totalInCents
      giftCardAmountInCents
      couponAmountInCents
    }
  }
`;

export const purchaseSubscriptionMutation = gql`
  mutation ECOMMERCE_purchaseSubscription($input: PurchaseSubscriptionInput!) {
    purchaseSubscription(input: $input) {
      chargeInvoice {
        number
      }
      giftCardInvoices {
        number
      }
      isGWP
      isReturningCustomer
    }
  }
`;

export const deviceSubscriptionQuery = gql`
  query ECOMMERCE_deviceSubscription($moduleId: String!) {
    device(moduleId: $moduleId) {
      subscription {
        currentTermEndsAt
      }
    }
  }
`;

export const purchaseSubscriptionDeviceQuery = gql`
  query ECOMMERCE_purchaseSubscriptionDevice(
    $moduleId: String!
    $inAppFlow: Boolean
    $monthlyUpgrade: Boolean
    $couponCode: String
    $currency: Currency
    $countryCode: CountryCode
  ) {
    device(moduleId: $moduleId) {
      ...purchaseSubscriptionDeviceDetails
    }
  }

  fragment allCurrencies on PricingByCurrency {
    USD
    CAD
    EUR
    GBP
    RON
  }

  fragment purchaseSubscriptionDeviceDetails on Device {
    id
    moduleId
    currentCollarModel
    purchasableSubscriptionOptions(
      inAppFlow: $inAppFlow
      monthlyUpgrade: $monthlyUpgrade
      couponCode: $couponCode
      currency: $currency
      countryCode: $countryCode
    ) {
      ...subscriptionOption
    }
    preselectedPlanCodeForNewSubscription
    prepaidSubscription {
      planCode
      orderSource
      renewalPlanCode
      freeMonths
      resellerPriceInCents
    }
    pet {
      ...purchaseSubscriptionPetDetails
    }
    subscription {
      id
      code
      billingEmail
      currentTermEndsAt
      expiresAt
      pausedAt
      isPaused
      isCanceled
      hasFreeTrialPlan
      isInTrialPeriod
      activatedAt
      subscriptionOption {
        name
        priceInCents
        pricingInCents {
          ...allCurrencies
        }
        activationFeeInCents
        activationFeePricingInCents {
          ...allCurrencies
        }
        billingCadence
        displayedRate
        displayedRateUnit
        renewalYears
        renewalMonths
        billingPeriodsPerTerm
        sku
        buyItMembership
      }
      pendingChanges {
        subscriptionOption {
          priceInCents
          pricingInCents {
            ...allCurrencies
          }
          renewalMonths
        }
      }
    }
    subscriptionAccessType
    hasSubscriptionOverride
    shouldOfferFreeMonthDuringCancellation
    shouldOfferPauseMonthDuringCancellation
    shouldOfferDowngradeDuringCancellation
    shouldOfferDiscountDuringClickToCancel
    shouldOfferFreeTrialCancelDeterrent
    canCancel
    canCancelDate
    subscriptionRenewalStatus {
      shouldOfferSubscriptionRenewal
    }
    upgradeRedeemed
  }

  fragment purchaseSubscriptionPetDetails on Pet {
    id
    name
    gender
    species
    photos {
      first {
        image {
          fullSize
        }
      }
    }
    household {
      pets {
        id
        name
        device {
          subscriptionAccessType
        }
        photos {
          first {
            image {
              fullSize
            }
          }
        }
      }
    }
  }

  fragment subscriptionOption on SubscriptionOption {
    sku
    name
    priceInCents
    pricingInCents {
      ...allCurrencies
    }
    billingCadence
    displayedRate
    displayedRateUnit
    fullRate
    fullRateUnit
    savings
    monthlyUpgradeSavings
    featured
    renewalYears
    activationFeeInCents
    renewalMonths
    billingPeriodsPerTerm
    upsellOnly
    buyItMembership
    valueLabel
    supportPlus
    couponExtensionMonths
    planSwitchCreditAppliedInCents
    planSwitchAmountChargedInCents
    isPlusPlan
  }
`;
